<template>
    <v-card class="soft-shadow px-3 py-1 mb-6">
        <v-card-title class="d-flex justify-space-between">
            <div>
                <v-icon right icon="success">mdi-comment-text-multiple-outline</v-icon>
                <span>التعليقات</span>
            </div>
            <div>
                <v-btn v-if="videoData.block_comments" depressed dark color="strong-text" @click="blockVideoComments(false)">
                    <v-icon left>mdi-minus-circle-off-outline</v-icon>
                    <span>إلغاء حظر التعليقات</span>
                </v-btn>
                <v-btn v-else depressed outlined color="strong-text" @click="blockVideoComments(true)">
                    <v-icon left>mdi-minus-circle-outline</v-icon>
                    <span>حظر التعليقات</span>
                </v-btn>
            </div>
        </v-card-title>
        <v-divider style="opacity: 0.6" class="mx-4"></v-divider>
        <v-card-text class="px-0">
            <v-list v-if="commentsData && commentsData.length" class="py-0">
                <transition-group name="scroll-y-transition">
                    <comment v-for="comment in commentsData" :comment="comment" :key="comment.id" class="mb-1"></comment>
                </transition-group>
            </v-list>
            <div v-else class="px-4">
                <v-alert dense text type="info" color="blue-grey" class="mb-0">
                    <span class="details-text">
                        لا يوجد تعليقات على هذا الفيديو
                    </span>
                </v-alert>
            </div>
            <div v-if="commentsNext || commentsPrev" class="px-4 mt-4">
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-btn :disabled="!commentsPrev" block text class="surface2" v-ripple="phoneOnly" @click="$emit('loadMoreComments', commentsPrev)">
                            <v-icon left>mdi-arrow-right</v-icon>
                            الصفحة السابقة
                        </v-btn>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-btn :disabled="!commentsNext" block text class="surface2" v-ripple="phoneOnly" @click="$emit('loadMoreComments', commentsNext)">
                            الصفحة التالية
                            <v-icon right>mdi-arrow-left</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Comment from './comment'

export default {
    props: {
        videoData: {},
        comments: {}
    },
    data(){
        return {
            connectedChannel: null,

            commentsData: null,
            commentsNext: null,
            commentsPrev: null,
        };
    },
    components: {Comment},
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
        setRealtime(){
            let channel = `Videos.${this.videoData.id}.Comments`;
            this.connectedChannel = channel;
            const self = this;
            window.Echo.private(channel)
                .listen('NewVideoComment', (response) => {
                    let data = response.data;
                    self.commentsData.unshift(data.data);
                    // this.autoResetScroll();
                });
        },
        leaveRealtime(){
            if (this.connectedChannel){
                window.Echo.leave(this.connectedChannel);
                // window.console.log('leaved: ' + this.connectedChannel);
            }
        },
        blockVideoComments(block){
            const url = `/videos/${this.videoData.id}/block-comments`;
            this.$store.dispatch('fastPutAction', {url, data: {block_comments: block}}).then(response=>{
                this.$emit('sync-video', response.data.data);
            }).catch(()=>{
                this.showMsg('حدثت مشكلة أثناء تنفيذ اﻹجراء', 'error');
            })
        },
    },
    mounted(){
        this.commentsData = this.comments ? this.comments.data : null;
        this.commentsNext = this.comments && this.comments.links && this.comments.links.next ? this.comments.meta.current_page+1 : null;
        this.commentsPrev = this.comments && this.comments.links && this.comments.links.prev ? this.comments.meta.current_page-1 : null;

        this.setRealtime();
    }
}
</script>

<style>

</style>
